import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { BillOfMaterial, BillOfMaterialCreate, BillOfMaterialFilter } from '../data/billOfMaterial';

export function createBillOfMaterialService(client: AxiosInstance) {
  return createCrudService<BillOfMaterial, BillOfMaterialCreate, BillOfMaterialFilter>(
    client,
    '/manufacturing/BillOfMaterial',
    'id',
  );
}

export type BillOfMaterialService = CrudService<BillOfMaterial, BillOfMaterialCreate, BillOfMaterialFilter>;
